// @ts-nocheck -- RARE-264 mechanical rename; type this file under RARE-265
import { cilTrash } from "@coreui/icons-pro";
import CIcon from "@coreui/icons-react";
import { CButton, CPopover } from "@coreui/react-pro";
import React, { useCallback, useEffect, useState } from "react";

const DeleteButton = ({
  title = "Delete Item?",
  message = <></>,
  onDelete = () => void 0,
  onCancel,
  buttonElement = undefined,
  ...props
}) => {
  const [visible, setVisible] = useState(false);
  const [children, setChildren] = useState(<span> </span>);

  const handleDelete = () => {
    onDelete();
    setVisible(false);
  };

  const defaultChild = (
    <CButton onClick={() => setVisible(true)} color={"danger"} variant={"outline"} {...props}>
      <CIcon icon={cilTrash} />
    </CButton>
  );

  const filterInvalid = useCallback(() => {
    if (React.Children.toArray(props.children).filter((c) => React.isValidElement()).length > 0) {
      setChildren(<span onClick={() => setVisible(!visible)}>{props.children}</span>);
    }
  }, [props.children]);

  useEffect(() => {
    try {
      if (!props.children) {
        setChildren(defaultChild);
      } else {
        const only = React.Children.only(props.children);
        if (only) {
          setChildren(React.cloneElement(only, { onClick: () => setVisible(!visible) }));
        }
      }
    } catch (e) {
      filterInvalid();
    }
  }, [props.children, filterInvalid]);

  return (
    <>
      <CPopover
        trigger={[]}
        title={title}
        content={
          <>
            {message}
            <div className={"d-flex"} style={{ minWidth: "10rem", maxWidth: "100%" }}>
              <CButton color={"primary"} size={"sm"} onClick={() => handleDelete()}>
                Delete
              </CButton>

              <CButton
                color={"primary"}
                variant={"outline"}
                className={"ms-auto"}
                onClick={() => setVisible(false)}
                size={"sm"}
              >
                Cancel
              </CButton>
            </div>
          </>
        }
        visible={visible}
      >
        {children}
      </CPopover>
    </>
  );
};

export default DeleteButton;
